import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import './Bienvenida.css';

export default function Bienvenida() {
  const location = useLocation();
  const navigate = useNavigate();
  const { name } = location.state || {};

  const cardRef = useRef(null);
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!name) {
      navigate('/plans');
      return;
    }

    const card = cardRef.current;
    const overlay = overlayRef.current;
    if (!card || !overlay) return;

    // Valores iniciales (scoped al card)
    card.style.setProperty('--x', '50%');
    card.style.setProperty('--y', '50%');
    card.style.setProperty('--circle-size', '0%');

    const handleMove = (e) => {
      const rect = card.getBoundingClientRect();
      const mouseX = ((e.clientX - rect.left) / rect.width) * 100;
      const mouseY = ((e.clientY - rect.top) / rect.height) * 100;

      const clampedX = Math.min(100, Math.max(0, mouseX));
      const clampedY = Math.min(100, Math.max(0, mouseY));

      const dx = Math.abs(50 - mouseX);
      const dy = Math.abs(50 - mouseY);
      const distance = Math.min(Math.sqrt(dx * dx + dy * dy), 50);

      // IMPORTANT: set vars en el CARD (scoped), no en :root
      card.style.setProperty('--x', `${clampedX}%`);
      card.style.setProperty('--y', `${clampedY}%`);
      card.style.setProperty('--circle-size', `${distance}%`);

      gsap.to(overlay, { opacity: 1, scale: 1, duration: 0.2, ease: 'sine.out' });
    };

    const handleLeave = () => {
      card.style.setProperty('--circle-size', '0%');
      gsap.to(overlay, { opacity: 0, duration: 0.25, ease: 'sine.inOut' });
    };

    card.addEventListener('mousemove', handleMove);
    card.addEventListener('mouseleave', handleLeave);

    return () => {
      card.removeEventListener('mousemove', handleMove);
      card.removeEventListener('mouseleave', handleLeave);
    };
  }, [name, navigate]);

  if (!name) return null;

  return (
    <div className="bienvenida-wrapper">
      <div className="bienvenida-container">
        <div className="card card-photo" ref={cardRef}>
          <div id="card1" className="card-photo">
            <div id="rowOne" className="firstPart">
              <h2>¡Bienvenido a la Escuela Online, {name}!</h2>
              <img
                src="https://images.unsplash.com/photo-1498673394965-85cb14905c89?auto=format&fit=crop&w=1000&q=80"
                alt="Estudiante feliz"
              />
            </div>
            <div className="container-text">
              <p>Tu cuenta ha sido creada con éxito 🎉</p>
              <div className="btn black" onClick={() => navigate('/plans')}>
                Ir a mis planes de estudio
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="svg_icon"
                >
                  <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
                </svg>
              </div>
            </div>
          </div>

          <div id="overlay" ref={overlayRef}>
            <div id="rowTwo" className="firstPart">
              <h2>¡Comienza tu camino de aprendizaje!</h2>
              <img
                src="https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?auto=format&fit=crop&w=1000&q=80"
                alt="Estudio online"
              />
            </div>
            <div className="container-text">
              <p>Explora todos nuestros módulos y recursos.</p>
              <div className="btn green" onClick={() => navigate('/plans')}>
                Ir ahora
                <svg className="svg_icon" viewBox="0 0 448 512">
                  <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* (Opcional) texto debajo o cualquier otro contenido scoped aquí */}
      </div>
    </div>
  );
}
